import $ from 'jquery';
import Isotope from 'isotope-layout';
import imagesLoaded from 'imagesloaded';

imagesLoaded.makeJQueryPlugin($);

const initializeBlock = function ($block) {
    const parent = $('.events-isotope');
    const iso = new Isotope('.events-isotope', {
        itemSelector: '.event-feed-template',
        percentPosition: true,
        masonry: {
            columnWidth: '.event-feed-template--sizer',
        },
    });

    parent.imagesLoaded(function () {
        iso.layout();
    });

    let qsRegex;

    const debounce = (fn, threshold) => {
        var timeout;
        threshold = threshold || 100;
        return function debounced() {
            clearTimeout(timeout);
            var args = arguments;
            var _this = this;
            function delayed() {
                fn.apply(_this, args);
            }
            timeout = setTimeout(delayed, threshold);
        };
    };

    const search = $('.events-filter-search').keyup(
        debounce(function () {
            qsRegex = new RegExp(search.val(), 'gi');

            iso.arrange({
                filter: function () {
                    return qsRegex ? $(this).find('.event-feed-template__title').text().match(qsRegex) : true;
                },
            });
        }, 200)
    );
};

$('.events-block').each(function () {
    initializeBlock($(this));
});

if (window.acf) {
    window.acf.addAction('render_block_preview/type=halles610-events', initializeBlock);
}
